import CC from "../../assets/logo/cc_logo.png";
import C from "../../assets/logo/c_logo.png";
import Kv from "../../assets/logo/kv_logo.png";

export const ccLogo = CC;
export const cLogo = C;
export const kvLogo = Kv;
